import { render } from "./PlantPriceOverview.vue?vue&type=template&id=d49af9a8"
import script from "./PlantPriceOverview.vue?vue&type=script&lang=js"
export * from "./PlantPriceOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__